export default "__VITE_ASSET__JP$rTHss__"